import classNames from "classnames";

import { ExtendedText } from "../features/emoji";

import { Link } from "./Link";
import { KibelaSymbol } from "./shared/kibela_symbol";

export interface GroupType {
  name: string;
  path: string;
  isPrivate: boolean;
}

type LabelProps = Readonly<{
  group: GroupType;
}>;

export const GroupLabelIcon: React.VFC<{ isPrivate: boolean }> = ({ isPrivate }) => {
  return isPrivate ? <KibelaSymbol id="lock-alt" /> : <i className="fa fa-users" />;
};

export const GroupLabel: React.FC<LabelProps> = ({ group }) => {
  return (
    <Link key={group.path} to={group.path} className={classNames("groupLabel", group.isPrivate && "is-group-private")}>
      <GroupLabelIcon isPrivate={group.isPrivate} />
      <ExtendedText>{group.name}</ExtendedText>
    </Link>
  );
};
